export default {
  choose_subject: "Fach auswählen",
  show_lesson: "Kurs anzeigen",
  course: "Kurs",
  lessonLink: "Link",
  activityDone: "Erledigte Aktivitäten",
  workToDo: "Vorzubereitende Arbeit",
  generalCourses: "Allgemeine Kurse",
  attachments: "Anhänge",
  attachment: "Anhang",
  download: "Herunterladen",
  "Taught subject": "Unterrichtetes Fach",
  lesson_info:
    "Dieses Menü ermöglicht die Konfiguration von Fächern in Verbindung mit verschiedenen Modulen: Kalender, Kompetenzen, Zeugnis",
  lesson_search_label: "Kurs oder Fach suchen",
  lesson_search_placeholder: "Schlüsselwörter: Kurs, Fach...",
  lesson_search_reset: "Suche löschen",
  lesson_search_no_result: "Kein Kurs entspricht Ihrer Suche",
  lessons_count: ({ plural }) => plural(["Kurs", "Kurse"]),
  lesson_search_results_count: ({ plural, named }) =>
    plural([`${named("count")} Kurs gefunden`, `${named("count")} Kurse gefunden`]),
};
